export enum ChartType {
  Recent = 'recent',
  EvenlySpaced = 'evenlySpaced',
  CTF = 'ctf',
  Historical = 'historical',
}